import axios from "axios";

const actionGetClosures = async ({commit}, payload) => {
  const closures = await axios.get(`${process.env.VUE_APP_URL_API}/v1/services/animal_explanations`, {params:payload});
  commit("SET_CLOSURES", closures.data.services);
  commit("SET_PAGINATION", closures.data.options.meta);
}

export default {
  actionGetClosures
}